import React, { useEffect, useState,useImperativeHandle,forwardRef, useRef  } from "react";
import { useSelector} from "react-redux";
import VIcon from "components/custom/Icon";
import { themeIcons } from "config/theme";
import { stringIsNullOrEmpty } from '../../util/Util'
import "../../assets/css/floatingchat.css"
import { useHistory, useLocation } from 'react-router-dom';
import { AnimatedList } from "react-animated-list";
import { ApiUrl , ApiKey, WebUrl, WebUrlKey} from "../../util/Constant";
import ApiEngine from "util/ApiEngine";

const FloatingChat = forwardRef((props, ref) => {
  var { heartBeat } = useSelector((state) => state.authState);
  
  const [shouldShowFloatChannel, setShouldShowFloatChannel] = useState(false);
  const [clickCloseFloatChannel, setClickCloseFloatChannel] = useState(false);
  const [FloatChannelImg,setFloatChannelImg]=useState("");

  const [iconColor, setIconColor] = useState('#FFF');
  const floatingChat = useSelector((state)=>state.appState.floatingChat);
  const location = useLocation();
  const _history = useHistory();
  const[channelList,setChannelList]=useState();


  const [isChannelListOpen, setIsChannelListOpen] = useState(false);
  const [spinnerWheelExist,setSpinnerWheelExist]=useState(true);
  const [seqPos,setSeqPos]=useState(2);

  const clickCloseRef = useRef(clickCloseFloatChannel);
  const prevImageUrlRef = useRef(null);

  const [isScrolling, setIsScrolling] = useState(false);
  const scrollTimeout = useRef(null);
  const isTelegramMiniApp = Boolean(
    window.Telegram?.WebApp?.initData &&
    window.Telegram?.WebApp?.initDataUnsafe?.user
  );

  useEffect(() => {
    // Update the ref whenever `clickCloseFloatChannel` changes
    clickCloseRef.current = clickCloseFloatChannel;
  }, [clickCloseFloatChannel]);

  useImperativeHandle(
    ref,
    () => ({
      changePos: (seq) => {
        setSeqPos(seq);
      },
    }),
    []
  );


	useEffect(() => {
        const parentElement = document.querySelector('.page-container');
    
        if(parentElement){
            const backgroundColor = window.getComputedStyle(parentElement).backgroundColor; 
            const isDarkTheme = isDarkBackground(backgroundColor);
            setIconColor(isDarkTheme ? '#FFF' : '#383838');
        }

        getFloatingChannel();
	}, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolling(true);

      // Clear previous timeout
      if (scrollTimeout.current) {
        clearTimeout(scrollTimeout.current);
      }

      // Detect scroll stop
      scrollTimeout.current = setTimeout(() => {
        setIsScrolling(false);
      }, 600); // adjust delay if needed
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (scrollTimeout.current) {
        clearTimeout(scrollTimeout.current);
      }
    };
  }, []);


  const getFloatingChannel = () => {
    try {
      const result = floatingChat;

      if (result) {
        const newImageUrl = result["imageUrl"];

        if (prevImageUrlRef.current !== newImageUrl) {
          setShouldShowFloatChannel(false);
          setImgLoad(false);
          setIsChannelListOpen(false);
          prevImageUrlRef.current = newImageUrl;
        }

        setFloatChannelImg(newImageUrl);
        setChannelList(result["channelList"]);

        if (!clickCloseRef.current) {
          setShouldShowFloatChannel(true);
        }else{
          setShouldShowFloatChannel(false);
        }
      } else {
        setShouldShowFloatChannel(false);
      }
    } catch (error) {
      setShouldShowFloatChannel(false);
    }
  };

  const isDarkBackground = (bgColor) => {
    const rgb = bgColor.match(/\d+/g);
    if (rgb) {
      const r = parseInt(rgb[0], 10);
      const g = parseInt(rgb[1], 10);
      const b = parseInt(rgb[2], 10);
      return (r * 0.299 + g * 0.587 + b * 0.114) < 128;
    }
    return false;
  };

  const openChannelLink = (cta) => {
    const urlKey = WebUrlKey[cta];
    if (urlKey) {
      _history.push(WebUrl[urlKey]);
      return;
    }
    if (!cta) return;
    window.open(cta, "_blank", "noopener,noreferrer");
  };

  const CloseBtn = (props)=> (
    <div
          className="float-channel-close-button" style={{ color: iconColor }}
          onClick={(e) => {
              e.stopPropagation();
              setShouldShowFloatChannel(false);
              setClickCloseFloatChannel(true);
          }}
    >
      <VIcon icon={themeIcons.close} className="vicon" />
    </div>
  );

  const [imgLoad, setImgLoad] = useState(false);

  useEffect(() => {
  if (!channelList) return;

  channelList.forEach(icon => {
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = icon.channelImage;
    document.head.appendChild(link);
  });
}, [channelList]);
	
  return (
    <>
    {shouldShowFloatChannel && location.pathname !== "/"+ WebUrl.getCurrentLocale() +"/livechat" && (
    <div className={`chat-floating-container n-${seqPos} ${isScrolling ? "hide-partial" : ""}`}>
       {isChannelListOpen && (
       <div className={`float-channel-icon-group ${isChannelListOpen ? "open" : ""}`}>
       <AnimatedList animation={"grow"}>
       {channelList && [...channelList].reverse().map((icon, index) => {
        const urlKey = WebUrlKey[icon.cta];
        return (
          <a
            key={index}
            href={urlKey ? WebUrl[urlKey] : icon.cta}
            target={urlKey ? "_self" : "_blank"}
            rel="noopener noreferrer"
            className="float-channel-circle-icon"
            onClick={(e) => {
              setIsChannelListOpen(false);
              if (!urlKey) return;
              e.preventDefault();
              _history.push(WebUrl[urlKey]);
            }}
          >
            <img src={icon.channelImage} alt="Icon" />
          </a>
        );
      })}</AnimatedList>
        </div>)}
      <button
        className={`float-channel-gif-button ${isTelegramMiniApp ? "display-none" : ""}`}
        onClick={() => {
          if (channelList?.length === 1) {
            openChannelLink(channelList[0]?.cta);
            return;
          }
          setIsChannelListOpen(!isChannelListOpen);
        }}
      >
        <img src={FloatChannelImg} alt="GIF" className="float-channel-gif-image" onLoad={() => setImgLoad(true)}/>
        {imgLoad && (
         <div
          className="float-channel-close-button" style={{ color: iconColor }}
          onClick={(e) => {
              e.stopPropagation();
              setShouldShowFloatChannel(false);
              setClickCloseFloatChannel(true);
          }}
         >
        <VIcon icon={themeIcons.close} className="vicon" />
        </div>
        )}
      </button>
    </div>
    )}
    </>
  );
 

});

export default FloatingChat;
